module.exports = __webpack_public_path__ + "static/media/dota.b82204e0.png";